import request from '@/utils/request';

/**
 * 查询客户管理导航栏设置接口
 * @param {*} data
 */
export function configHeaderModelSortAPI(data) {
  return request({
    url: 'admin/index/sort',
    method: 'post',
    data: data
  });
}

/**
 * 修改首页顶部导航栏设置接口
 * @param {*} data
 */
export function configSetHeaderModelSortAPI(data) {
  return request({
    url: 'admin/index/updatesort',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}
// 其它设置, 公海设置
export function getSeaSetting() {
  return request({
    url: 'admin/setting/configV2Info',
    method: 'post',
    data: {},
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}

// 其它设置, 公海设置保存
export function seaSettingSave(data) {
  return request({
    url: 'admin/setting/configV2Save',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}
